'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = [{
  label: '(GMT -11:00)',
  value: 11 * 60
}, {
  label: '(GMT -10:00)',
  value: 10 * 60
}, {
  label: '(GMT -09:00)',
  value: 9 * 60
}, {
  label: '(GMT -08:00)',
  value: 8 * 60
}, {
  label: '(GMT -07:00)',
  value: 7 * 60
}, {
  label: '(GMT -06:00)',
  value: 6 * 60
}, {
  label: '(GMT -05:00)',
  value: 5 * 60
}, {
  label: '(GMT -04:30)',
  value: 4.5 * 60
}, {
  label: '(GMT -04:00)',
  value: 4 * 60
}, {
  label: '(GMT -03:30)',
  value: 3.5 * 60
}, {
  label: '(GMT -03:00)',
  value: 3 * 60
}, {
  label: '(GMT -02:00)',
  value: 2 * 60
}, {
  label: '(GMT -01:00)',
  value: 60
}, {
  label: '(GMT 00:00)',
  value: 0
}, {
  label: '(GMT +01:00)',
  value: -1 * 60
}, {
  label: '(GMT +02:00)',
  value: -2 * 60
}, {
  label: '(GMT +03:00)',
  value: -3 * 60
}, {
  label: '(GMT +03:30)',
  value: -3.5 * 60
}, {
  label: '(GMT +04:00)',
  value: -4 * 60
}, {
  label: '(GMT +04:30)',
  value: -4.5 * 60
}, {
  label: '(GMT +05:00)',
  value: -5 * 60
}, {
  label: '(GMT +05:30)',
  value: -6 * 60
}, {
  label: '(GMT +05:45)',
  value: -5 * 60 + 45
}, {
  label: '(GMT +06:00)',
  value: -6 * 60
}, {
  label: '(GMT +07:00)',
  value: -7 * 60
}, {
  label: '(GMT +08:00)',
  value: -8 * 60
}, {
  label: '(GMT +09:00)',
  value: -9 * 60
}, {
  label: '(GMT +09:30)',
  value: -9.5 * 60
}, {
  label: '(GMT +10:00)',
  value: -10 * 60
}, {
  label: '(GMT +11:00)',
  value: -11 * 60
}, {
  label: '(GMT +12:00)',
  value: -12 * 60
}];